import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './LegalPage.css';

export default function LegalPage() {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const isPrivacy = pathname === '/privacy';

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <h1>{isPrivacy ? t.legal.privacyTitle : t.legal.title}</h1>
        </div>
      </div>
      <section className="section legal-content">
        <div className="container">
          <div className="legal-card card">
            {!isPrivacy && (
              <>
                <h2>{t.legal.termsTitle}</h2>
                <p>{t.legal.termsText}</p>
                <h2>{t.legal.refundTitle}</h2>
                <p>{t.legal.refundText}</p>
              </>
            )}
            <h2>{t.legal.privacyTitle}</h2>
            <p>{t.legal.privacyText}</p>
          </div>
        </div>
      </section>
    </>
  );
}
